var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopIntroWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 922,
    height: 480,
    viewBox: "0 0 922 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517 89.5C504 106.5 526.961 115.043 526.961 115.043L875.303 139.101L997.829 95.422L974.842 39.7017C973.775 37.2157 972.85 34.671 972.073 32.0799C970.449 26.3687 967.59 21.0842 963.698 16.6006C959.805 12.117 954.975 8.5439 949.548 6.13427L946.62 4.83152C939.535 1.67714 931.871 0.0319012 924.115 0.000459338C916.359 -0.0309825 908.682 1.55205 901.571 4.64888L807.121 39.4521C791.006 46.4734 773.61 50.0739 756.032 50.0257C738.454 49.9775 721.077 46.2817 705.001 39.172L617.588 6.42039C601.151 -0.884804 573.373 0.235331 557.862 9.35465C549.559 14.2366 543.266 21.915 540.11 31.0145C534.95 45.8976 530 72.5 517 89.5Z",
    fill: "#2BACCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M972.242 434.21C587.71 425.808 96.4258 472.206 3.99998 409.655C-4.16669 396.77 1.73016 369.498 31.5 345C54.6813 325.924 282 302 340 232.5C398 163 407 139.5 451 94.5C495 49.5 898.941 58.9119 898.941 58.9119C921.179 58.9119 934.48 138.508 934.48 138.508L972.242 434.21Z",
    fill: "#2BACCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIntroWave);
export default __webpack_public_path__ + "static/media/top-intro-wave.62f4b06dea2492541fee8be40fbca711.svg";
export { ForwardRef as ReactComponent };